import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";

import { fetchMenu } from "../core/redux/api/menu";

import SortableTree from "react-sortable-tree";
import "react-sortable-tree/style.css";

import MenuDialog from "./MenuDialog";
import GKEvent from "../events";

import MenuItem from "./MenuItem";
import Icon from "./Icons";
import { ajaxUri } from "../consts/index";
import { l } from "../functions";

const mapStateToProps = (state) => {
  return {
    fetchedMenu: state.rootReducer.fetchedMenu || [],
    currentLang: state.rootReducer.currentLang || 1,
  };
};

const fetchItemsLevel = (items) => {
  let leveledItems = {};

  for (const item of items) {
    leveledItems[item.data.menu_id] = parseInt(item.data.level);

    if (item.children)
      leveledItems = { ...leveledItems, ...fetchItemsLevel(item.children) };
  }

  return leveledItems;
};

class MenuItems extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      currentMenu: null,
      menuDatas: {},
      openDialog: false,
    };

    this.state = {
      ...{ treeData: this.props.fetchedMenu },
      ...this.defaultState,
    };
  }

  componentWillReceiveProps({ fetchedMenu }) {
    const oldFetchedMenu = this.props.fetchedMenu;

    if (
      oldFetchedMenu === null ||
      JSON.stringify(fetchedMenu) !== JSON.stringify(oldFetchedMenu)
    )
      this.setState({ treeData: fetchedMenu });
  }

  _listActions = (menu_id) => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "getMenuDatas",
        menu_id: menu_id,
      },
    })
      .then((result) => {
        this.setState({
          currentMenu: result.data,
          menuDatas: result.data,
        });
      })
      .catch((error) => {});
  };

  _onClose = () => {
    this.setState(this.defaultState);
  };

  _onSubmit = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "updateMenuDatas",
        menu_id: this.state.currentMenu.menu_id,
        settings: this.state.menuDatas,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState(this.defaultState, () => {
            this.props.fetchMenu();
          });

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while updating the menu. Please try again.")
        );
      });
  };

  _changedValue = (key, value) => {
    let label = {};
    try {
      label = JSON.parse(this.state.menuDatas.label || "{}");
    } catch (err) {
      console.log(err);
    }

    const strJson = JSON.stringify({
      ...label,
      ...{ [key.replace("label_", "")]: value },
    });

    if (key.includes("label_"))
      this.setState({
        ...this.state,
        menuDatas: {
          ...this.state.menuDatas,
          label: strJson,
        },
      });
    else
      this.setState({
        ...this.state,
        menuDatas: {
          ...this.state.menuDatas,
          [key]: value,
        },
      });
  };

  _changeOrder = (tree) => {
    this.setState(
      {
        treeData: tree,
      },
      () => {
        axios({
          method: "post",
          url: ajaxUri,
          data: {
            request: "changeMenuOrder",
            tree: tree,
          },
        })
          .then((result) => {
            GKEvent.notification(result.data.status, result.data.message);
          })
          .catch((error) => {});
      }
    );
  };

  _newMenu = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "createMenu",
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState(this.defaultState, () => {
            this.props.fetchMenu();
          });

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while creating new menu. Please try again.")
        );
      });
  };

  _removeMenu = () => {
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "removeMenu",
        menu_id: this.state.currentMenu.menu_id,
        parent_id: this.state.currentMenu.parent_id,
      },
    })
      .then((result) => {
        if (result.data.status === "success")
          this.setState(this.defaultState, () => {
            this.props.fetchMenu();
          });

        GKEvent.notification(result.data.status, result.data.message);
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while removing menu. Please try again.")
        );
      });
  };

  render() {
    return (
      <div>
        <MenuDialog
          menuDatas={this.state.menuDatas}
          currentMenu={this.state.currentMenu}
          open={this.state.openDialog}
          onClose={this._onClose}
          onSubmit={this._onSubmit}
          onChange={this._changedValue}
        />
        <button className="new-item" onClick={this._newMenu}>
          <Icon icon="plus" />
        </button>
        <div className="menu-items">
          <SortableTree
            treeData={this.state.treeData}
            onChange={this._changeOrder}
            rowHeight={56}
            scaffoldBlockPxWidth={32}
            generateNodeProps={(rowInfo) => {
              let nodeProps = {
                treeData: fetchItemsLevel(this.state.treeData),
                actions: this.state.currentMenu ? true : false,
                currentLang: this.props.currentLang,
                unListActions: (event) => {
                  this._onClose();
                },
                listActions: (event) => {
                  this._listActions(rowInfo.node.data.menu_id);
                },
                editMenu: (event) => {
                  this.setState({ openDialog: true });
                },
                removeMenu: (event) => {
                  this._removeMenu();
                },
              };
              return nodeProps;
            }}
            nodeContentRenderer={MenuItem}
            isVirtualized={false}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, { fetchMenu })(MenuItems);
